import { getSettings } from "./get-settings";

const DEFAULT_TIMEOUT = 10000;

export const plainFetcher = async (url: string, props?: any) => {
  const settings = await getSettings();

  const newProps = { ...props };
  newProps.headers = {
    "X-ASH-Authorization": window.localStorage.getItem("accessToken"),
    "X-Frame-Options": "DENY",
    ...newProps.headers,
  };

  const response = await fetch((settings.apiEndpoint ?? "") + url, newProps);
  return handleErrors(response, url);
};

export const fetcher = async (url: string, props?: any) => {
  const response = await plainFetcher(url, props);
  const responseJson = await response.json();

  // RTW returns this special attribute so that it doesn't mix up with MX use case.
  // Backend set-up could be find here:
  // https://code.amazon.com/packages/HvhSimpleHireChecklistServer/blobs/36f324e9ad32efc94fc3926eaee1ba3c2033e57b/--/src/accessor/caas-accessor.ts#L302
  if (responseJson.rightToWork) {
    return responseJson.rightToWork;
  }

  return responseJson;
};

// Temporary fix for duplicate API calls. Cache will be cleared after refreshing the page
let cachedRequests: Record<string, Promise<any>> = {};

export const deleteCachedRequest = () => {
  cachedRequests = {};
};

export const fetchWithTimeout = (url: string, timeout = DEFAULT_TIMEOUT, props?: any) => {
  if (!cachedRequests[url]) {
    cachedRequests[url] = Promise.race([
      fetcher(url, props),
      new Promise((_, reject) => {
        setTimeout(() => reject(new Error("Timeout")), timeout);
      }),
    ]);
  }

  return cachedRequests[url];
};

function handleErrors(response: Response, url: string) {
  if (!response.ok) {
    throw Error(`Http error when requesting ${url}: ${response.status}, ${response.statusText}`);
  }
  return response;
}
